import React from 'react';
import { NFTData } from '../types';
import NFTCard from './NFTCard';

interface NFTGridProps {
  nfts: NFTData[];
  onNFTClick: (nft: NFTData) => void;
}

const NFTGrid: React.FC<NFTGridProps> = ({ nfts, onNFTClick }) => {
  if (nfts.length === 0) {
    return (
      <div className="empty">
        <div className="empty-text">
          No NFTs found. The collection might be empty or still loading.
        </div>
      </div>
    );
  }

  return (
    <div className="grid-wrap">
      {nfts.map((nft) => (
        <NFTCard
          key={nft.tokenId}
          nft={nft}
          onClick={() => onNFTClick(nft)}
        />
      ))}
    </div>
  );
};

export default NFTGrid;
